'use strict';

/**
 * Used to extend Resource with group functionality.
 *
 * - groupings: a collection containing all of the individual grouping 
    {
      CarMakers: {Toyota, Honda, Chevy},
      Years: {2012, 2013, 2014}
    }
 * - grouping: a collection of grouped models, i.e. only CarMarkers {Toyota, Honda, Chevy}
 * - group: a collection of models that share the same group, i.e. only {Toyota} cars
 */

var _ = require('lodash');

module.exports = {

  $groupings: null,

  /**
   * Add a model to the specified group
   * 
   * @param {Object} model
   * @param {Object} group
   */
  addToGroup: function (model, group) {
    var modelId = model.get('id');

    // add all list items to the "list" attribute
    group.list[modelId] = model;
    group.count++;
  },

  /**
   * Add a model or array of models to the specified grouping
   * 
   * @param {Object|Array} data model or list of models
   * @param {String} attr model attribute to group on
   * @param {String} [labelAttr] optional model attribute to use to label the group with
   */
  addToGrouping: function (data, attr, labelAttr) {
    var this_ = this;
    var grouping = this.$groupings[attr];

    if (Array.isArray(data)) {
      this.$groupings[attr] = _.reduce(data, function (grouping, model) {
        return addModel(model, grouping);
      }, grouping);
    } else {
      var model = data;
      this.$groupings[attr] = addModel(model, grouping);
    }

    function addModel (model, grouping) {
      var groupId = model.get(attr);
      var group = grouping[groupId];

      if (!group) {
        var label = labelAttr && model.get(labelAttr);
        group = newGroup(groupId, label);
      }

      this_.addToGroup(model, group);
      grouping[groupId] = group;
      return grouping;
    }

    function newGroup (groupId, label) {

      // set the meta model
      var group = {
        id: groupId,
        attr: attr,
        count: 0,
        label: label || groupId
      };

      // all models will be added to "list"
      group.list = {};

      return group;
    }

    return this.$groupings[attr];
  },

  /**
   * Add model to all existing groupings.
   * This will not create a new grouping(s) if it does not exist.
   * 
   * @param {Object} model resource model instance
   */
  addToGroupings: function (model) {
    var this_ = this;
    _.forEach(this.$groupings, function (grouping, attr) {
      var groupId = model.get(attr);
      var group = grouping[groupId];
      if (group) {
        this_.addToGroup(model, group);
      }
    });
  },

  /**
   * Add or create a new grouping using the specified model attribute, optionally passing in the array of 
   * models to populate the grouping with.
   * 
   * @param  {Object|Array} [data] model or array of models to populate the grouping with
   * @param  {String} attr model attribute used to group the models on
   * @param  {String} [labelAttr] optional model attribute to use to label the group with
   */
  addOrCreateGrouping: function (data, attr, labelAttr) {
    this.$groupings = this.$groupings || [];
    if (!this.$groupings || !this.$groupings[attr]) {
      this.createGrouping(data, attr, labelAttr);
    } else {
      this.addToGrouping(data, attr, labelAttr);
    }
  },

  /**
   * Create a new grouping using the specified model attribute, optionally passing in the array of 
   * models to populate the grouping with.
   * 
   * @param  {Object|Array} [data] model or array of models to populate the grouping with
   * @param  {String} attr model attribute used to group the models on
   * @param  {String} [labelAttr] optional model attribute to use to label the group with
   */
  createGrouping: function (data, attr, labelAttr) {
    this.$groupings = this.$groupings || {};
    this.$groupings[attr] = {};

    if (data) {
      this.$groupings[attr] = this.addToGrouping(data, attr, labelAttr);
    }

    return this.$groupings[attr];
  },

  /**
   * Retrieve a group by id. Without the "attr" (grouping id) the first group in any 
   * grouping that matches the given id will be returned.
   * 
   * @param  {String} id
   * @param  {String} [attr] grouping id
   * @return {Object} group
   */
  getGroup: function (id, attr) {
    var group;
    
    if (!attr) {
      _.find(this.$groupings, function (grouping) {
        group = grouping[id];
        return group !== undefined;
      });
    } else {
      var grouping = this.getGrouping(attr);
      group = grouping[id];
    }

    return group;
  },

  getGrouping: function (attr) {
    return this.$groupings[attr];
  },

  /**
   * Removes a model from the specified group
   * 
   * @param  {Object|String} model or model ID
   * @param  {String} attr the attr used to build the grouping (the groupingId)
   */
  removeFromGroup: function (model, group) {
    var id;
    
    if (typeof model === 'object') {
      id = model.get('id');
    } else {
      id = model;
    }

    if (group.list[id]) {
      delete group.list[id];
      group.count--;

      if (!group.count) {
        this.removeGroup(group);
      }
    }
  },

  /**
   * Remove the model from all groupings
   * 
   * @param  {Object} model resource model instance
   */
  removeFromGroupings: function (model) {
    // TODO
  },

  /**
   * Remove the specified group from it's grouping
   * 
   * @param  {Object} group
   */
  removeGroup: function (group) {
    var grouping = this.$groupings[group.attr];
    var groupId = group.id;
    
    if (grouping[groupId]) {
      delete grouping[group.id];
    } else {
      throw new Error('Unknown group ' + groupId + ' in ' + ' grouping by ' + group.attr);
    }

    return grouping;
  }
};


// WEBPACK FOOTER //
// ./~/@skycatch/skydash-saturn/boosters/data/src/core/mixins/Group.js